module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n6r5r1n-271363d8509b91af722420ab56c19f7f.svg";